import Grid from '../common/grid';
import List from '../common/list';
import { FilterContainer } from '../filter/filter-container';
import { Container, MaxContainer } from '../layout/container';
import Layout from '../layout/layout';

export const CategoryDetail = ({ category, preview, items }) => {
  return (
    <Layout
      preview={preview}
      title={category.seoTitle}
      description={category.seoDescription}
    >
      {category.slug === 'wein' ? (
        <MaxContainer>
          <div
            className='pb-4 pt-6'
            dangerouslySetInnerHTML={{ __html: category.description }}
          />
          <FilterContainer defaultResults={items} />
        </MaxContainer>
      ) : (
        <Container>
          <div
            className='ml-[5px] py-6'
            dangerouslySetInnerHTML={{ __html: category.description }}
          />
          <List
            items={items}
            Wrapper={Grid}
            listName={category.name}
            emptyClassName='ml-[5px]'
          />
        </Container>
      )}
    </Layout>
  );
};
